'use strict';

var _ = require('lodash');
var ServiceFilterBuilderService = function ServiceFilterBuilderService(SearchCriteriaRule) {
  function extractServiceId(serviceId) {
    var cutOffIndex = -2;
    if (_.endsWith(serviceId.toUpperCase(), '.MAPPED') || _.endsWith(serviceId.toUpperCase(), '.REGULAR')) {
      cutOffIndex = -3;
    }
    return serviceId.split('.').slice(0, cutOffIndex).join('.');
  }
  function extractServiceIds(data) {
    return _.chain(data).map(function (item) {
      return extractServiceId(item);
    }).uniq().value();
  }
  function buildFilter(data) {
    var serviceIds = extractServiceIds(data);
    if (!Array.isArray(serviceIds) || serviceIds.length === 0) {
      serviceIds = '';
    }
    var rule = new SearchCriteriaRule({
      field: 'serviceId',
      operator: '=',
      leftOperand: serviceIds
    });
    return [rule];
  }
  return {
    buildFilter: buildFilter
  };
};
ServiceFilterBuilderService.$inject = ['SearchCriteriaRuleFactory'];
module.exports = ServiceFilterBuilderService;